module.exports = __webpack_public_path__ + "img/address.1388e69a.jpg";